$(document).foundation();

$(document).ready(function($) {
  // navigasi brand
  if ($('.tax-brand-category').length > 0) {
    $('.tax-brand-category .filter-container').on('ccm.filter.done', function($clickedFilter) {
      Foundation.reInit('equalizer');
      $('html,body').animate({scrollTop: $('#category-brands-list').offset().top - pageDimensions.headerHeight - 32}, 500);  
      setTimeout(function() {
        $(window).trigger('resize');
      }, 500);
    });
    $('.tax-brand-category .filter-container [data-filter-criteria="brand-category"][data-filter-value="."]').addClass('filter-criteria-selected');
    $('.tax-brand-category .brands-grid .brand').addClass('filter-selected');
    Foundation.reInit('equalizer');  
  }
  $('.dropdown-options a').on("click", function() {
    var text = $(this).html();
    $(this).parents('.dropdown').find('.dropdown-selected a > span:first-child').html(text);
  });
  // product gallery
  $('.product-images-carousel').each(function() {
    $(this).flickity({
      cellSelector: '.carousel-cell',
      cellAlign: 'left',
      wrapAround: true,
      draggable: true,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: false,
      fullscreen: true,
    });
    $(this).on('settle.flickity', function(event, index) {
      var flickityData = $(this).data('flickity');
      var $cell = $(flickityData.selectedElement);
      $cell.siblings().find('video').each(function() {
        this.pause();
      })
      var $video = $cell.find('video');
      if ($video.length > 0) {
        $video.get(0).play();
      }
    })
    $(this).on('staticClick.flickity', function() {
      $(this).find('.flickity-fullscreen-button.flickity-fullscreen-button-view').trigger("click");
    })
  });
  // YT video embed
  $('.video-reveal')
    .on('open.zf.reveal', function() {
      var $videoContainer = $(this).find('> div');
      var containerWidth = $videoContainer.width();
      var containerHeight = $videoContainer.height();
      if (containerWidth > containerHeight) {
        containerWidth = Math.round(16 / 9 * containerHeight);
      } else {
        containerHeight = Math.round(9 / 16 * containerWidth);
      }
      $(this).find('.responsive-embed').css({
        'width': containerWidth,
        'height': containerHeight,
        'padding-bottom': 0,
      })
      console.log($videoContainer.innerWidth(),$videoContainer.height());
      $(this).find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + "playVideo" + '","args":""}','*');
    })
    .on('closed.zf.reveal', function() {
      $(this).find('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}','*');
    });
  // product images
  $('.carousel-nav a').on('click', function(e) {
    e.preventDefault();
    var navIdx = parseInt($(this).data('carousel-nav-idx'));
    $(this).parents('.carousel-nav').siblings('.carousel').flickity('select', navIdx, true);
  });
});
